<template>
    <div class="bind">
        <div class="login box">
            <div class="logo box">
                <img src="@/assets/img/logo.png" alt="">
                <div class="p1">欢迎使用海查查</div>
                <div class="p2">为了更好的服务请先绑定手机号</div>
            </div>
            <div class="item item1">
                <input type="number" v-model="phone" placeholder="请输入手机号" maxlength="11" />
            </div>
            <div class="item yzm">
                <input type="number" v-model="code" placeholder="请输入验证码" />
                <button :class="{gray:gray}" :disabled="disabled" @click="getcid">{{ cid }}</button>
            </div>
            <button class="weui-btn weui-btn_default weui-btn_loading submit" @click="bindPhone()" :disabled='loading'>
                <span class="weui-primary-loading" v-show="loading"><i class="weui-primary-loading__dot"></i></span>
                立即绑定</button>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
export default {
    name: "bindPhone",
    components: {

    },
    data() {
        return {
            cid: "获取验证码",
            code: '',
            time: 60,
            disabled: false,
            phone: "",
            code: "",
            isok: 0,
            isdown: false,
            isphone: false,
            loading: false,
            gray: false
        };
    },
    created() {
    },
    methods: {
        animate() {
            var re = /^1[3-9]\d{9}$/;
            if (re.test(this.phone)) {
                this.isok = 1;
                this.isphone = true;
            } else {
                this.isphone = false;
                this.$weui.topTips('请填写正确的手机号')
            }
        },
        getcid() {
            this.animate();
            if (this.isok == 1) {
                if (this.time == 60) this.getcidsum();
                if (this.time > 0) {
                    this.isok = 0;
                    this.cid = this.time + "s重试";
                    this.gray = true
                    this.disabled = true;
                    this.time--;
                    setTimeout(this.getcid, 1000);
                } else {
                    this.time = 60;
                    this.disabled = false;
                    this.cid = "获取验证码";
                    this.gray = false
                }
            }
        },
        getcidsum() {
            this.$http.get("/wx/sendCode", {
                params: {
                    phone: this.phone,
                },
            }).then(response => {
                if (response.data.code == 0) {
                    this.$weui.toast("验证码发送成功");
                }
            }).catch(function (error) { });
        },
        getUser() {
            this.$http.post("/wx/userInfo").then(res => {
                if (res.data.code == 0) {
                    this.$store.commit("setUser", res.data.data);
                    this.$router.push('/home')
                    this.$weui.toast("绑定成功")
                }
            });
        },
        bindPhone() {
            this.animate();
            if (!this.code) {
               this.$weui.topTips("验证码不能为空！")
            }else{
                 let json = {
                    code: this.code,
                    phone: this.phone
                }
                this.loading = true
                this.$http.post("/wx/addUserPhone", json).then(res => {
                    if (res.data.code == 0) {
                        this.getUser()
                    }else{
                        this.loading=false;
                    }
                }).catch(()=>{
                    this.loading=false;
                });
            }

        },
    },
    mounted() {

    }
};
</script>

<style lang='less' scoped>
.bind {
    width:100%;
    height: 100vh;
    background: url('../../assets/img/bac.png') no-repeat top center;
    background-size: 100%;
    .login {
        width: 630px;
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -315px;
        .logo {
            width: 630px;
            margin-top: 100px;
            img {
                width: 100px;
            }
            .p1 {
                font-size: 40px;
                color: #333333;
                padding: 30px 0 10px;
            }
            .p2 {
                font-size: 26px;
                color: #999999;
                padding-bottom: 47px;
            }
        }
        .item {
            width: 630px;
            margin: 0 auto;
        }
        .item1 {
            input {
                padding-left: 64px;
                width: 566px;
                height: 100px;
                border-bottom: 1px solid #eeeeee;
                font-size: 28px;
                background: url("../../assets/img/phone.png") no-repeat left
                    center;
                background-size: 40px auto;
            }
        }
        .yzm {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #eeeeee;
            justify-content: space-between;
            height: 100px;
            input {
                font-size: 28px;
                padding-left: 64px;
                background: url("../../assets/img/yzm.png") no-repeat left
                    center;
                background-size: 40px auto;
            }
            button {
                width: 168px;
                height: 50px;
                font-size: 24px;
                background: #2865ff;
                color: #ffffff;
            }
            .gray {
                background: #f5f5f5;
                color: #333333;
            }
        }
        .submit {
            width: 630px;
            height: 90px;
            margin: 80px auto 0;
            background: #2865ff;
            border-radius: 45px;
            border-radius: 45px;
            font-size: 34px;
            color: #ffffff;
        }
        .weui-primary-loading {
            color: #ffffff;
        }
    }
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/*** 消除input元素 type="number" 时默认的 加减按钮---moz版*/
input[type="number"] {
    -moz-appearance: textfield;
}

::-webkit-input-placeholder {
    font-size: 30px;
    color: #cccccc;
}
</style>